








































































































































































































































import Vue from 'vue'
import * as html2pdf from 'html2pdf.js'
import Site from '@/components/SeismicInsepctionForm/Site.vue'
import Geometry from '@/components/SeismicInsepctionForm/Geometry.vue'
import ValveAndLocation from '@/components/SeismicInsepctionForm/ValveAndLocation.vue'
import Specificities from '@/components/SeismicInsepctionForm/Specificities.vue'
import Conclusion from '@/components/SeismicInsepctionForm/Conclusion.vue'
import ConclusionDeresma from '@/components/SeismicInsepctionForm/ConclusionDeresma.vue'
import ConclusionDeresmaGaine from '@/components/DeresmaGaine/ConclusionDeresmaGaine.vue'
import Applicability from '@/components/SeismicInsepctionForm/Applicability.vue'
import SimpleTrunk1 from '@/components/SeismicInsepctionForm/SimpleTrunkAnalysis.vue'
import SimpleTrunk2 from '@/components/SeismicInsepctionForm/SimpleTrunkAnalysis2.vue'
import SimpleTrunk22 from '@/components/SeismicInsepctionForm/SimpleTrunkAnalysis2-2.vue'
import SimpleTrunk3 from '@/components/SeismicInsepctionForm/SimpleTrunkAnalysis3.vue'
import SimpleTrunk32 from '@/components/SeismicInsepctionForm/SimpleTrunkAnalysis3-2.vue'
import SimpleTrunk4 from '@/components/SeismicInsepctionForm/SimpleTrunkAnalysis4.vue'
import SensibleTrunk from '@/components/SeismicInsepctionForm/SensibleTrunkAnalysis.vue'
import SensibleTrunk2 from '@/components/SeismicInsepctionForm/SensibleTrunkAnalysis2.vue'
import TeamSignature from '@/components/SeismicInsepctionForm/TeamSignatures.vue'
import MethodApplicability from '@/components/SeismicInsepctionForm/MethodApplicability.vue'
import SeismicRexApplicability from '@/components/SeismicInsepctionForm/SeismicRexApplicability.vue'
import InspectionCriteria from '@/components/SeismicInsepctionForm/InspectionCriteria.vue'
import InspectionCriteria1a from '@/components/SeismicInsepctionForm/InspectionCriteria1a.vue'
import InspectionCriteria2 from '@/components/SeismicInsepctionForm/InspectionCriteria2.vue'
import InspectionCriteria3 from '@/components/SeismicInsepctionForm/InspectionCriteria3.vue'
import InspectionCriteria4 from '@/components/SeismicInsepctionForm/InspectionCriteria4.vue'
import InspectionCriteria4a from '@/components/SeismicInsepctionForm/InspectionCriteria4a.vue'
import InspectionCriteria5 from '@/components/SeismicInsepctionForm/InspectionCriteria5.vue'
import InspectionCriteria5a from '@/components/SeismicInsepctionForm/InspectionCriteria5a.vue'
import InspectionCriteria6 from '@/components/SeismicInsepctionForm/InspectionCriteria6.vue'
import SeismicCapacity from '@/components/SeismicInsepctionForm/SeismicCapacity.vue'
import SeismicForm from '@/models/SeismicForm'
import { mapGetters, mapActions } from 'vuex'
import Input from '@/components/ui/Input.vue'
import Inspector from '@/models/Inspector'
import Gaines1 from "@/components/DeresmaGaine/Gaines1.vue"
import Gaines2 from "@/components/DeresmaGaine/Gaines2.vue"
import GeometryGaine from "@/components/DeresmaGaine/Geometry.vue"
import Registres from "@/components/DeresmaGaine/Registres.vue"
import Supports from "@/components/DeresmaGaine/Supports.vue"
import Ancrages from "@/components/DeresmaGaine/Ancrages.vue"
import InteractionSismique from "@/components/DeresmaGaine/InteractionSismique.vue"
import CapaciteSismiqueGaine from "@/components/DeresmaGaine/CapaciteSismiqueGaine.vue"
import CapaciteSismiqueSupport from "@/components/DeresmaGaine/CapaciteSismiqueSupport.vue"

export default Vue.extend({
  name: 'printable-form',
  props: {
    form: { type: [SeismicForm, Object] }
  },
  data: () => {
    return {
      campaign: '',
      campaignForms: [] as Array<SeismicForm>,
      activeForm: undefined as SeismicForm | undefined,
      activeFormIndex: 0,
      pendingImport: false,
      campaignEndDate: new Date().toISOString().split('T')[0]
    }
  },
  computed: {
    ...mapGetters(['getSeismicForms', 'getInspectors']),
    inspectors () {
      const inspectors: Array<Inspector> = []
      this.campaignForms.forEach((form: SeismicForm) => {
        // eslint-disable-next-line no-unused-expressions
        form.inspectors?.forEach((inspec: Inspector) => {
          if (!inspectors?.find((i: Inspector) => i.firstName === inspec.firstName && i.lastName === inspec.lastName)) {
            inspectors.push(inspec)
          }
        })
      })
      return inspectors
    },
    alreadyExistingInspectors (): Array<Inspector> {
      const output: Array<Inspector> = []
      this.inspectors.forEach((inspector: Inspector) => {
        const existingInspector = this.getInspectors?.find((i: Inspector) => i.firstName === inspector.firstName && i.lastName === inspector.lastName)
        if (existingInspector) {
          output.push(existingInspector)
        }
      })
      return output
    },
    unknownInspectors (): Array<Inspector> {
      const output: Array<Inspector> = []
      this.inspectors.forEach((inspector: Inspector) => {
        if (!this.getInspectors?.find((i: Inspector) => i.firstName === inspector.firstName && i.lastName === inspector.lastName)) {
          output.push(inspector)
        }
      })
      return output
    },

    // returns the list of forms that don't have at least one inspector
    notSignedForms (): Array<SeismicForm> {
      const output: Array<SeismicForm> = []
      this.campaignForms.forEach((form: SeismicForm) => {
        if (!form.inspectors || form.inspectors.length === 0) {
          output.push(form)
        }
      })
      return output
    }
  },
  components: {
    CapaciteSismiqueSupport,
    CapaciteSismiqueGaine,
    InteractionSismique,
    GeometryGaine,
    Ancrages,
    Supports,
    Registres,
    Gaines2,
    Gaines1,
    Input,
    Site,
    Geometry,
    ValveAndLocation,
    Specificities,
    Conclusion,
    ConclusionDeresma,
    ConclusionDeresmaGaine,
    TeamSignature,
    Applicability,
    SimpleTrunk1,
    SimpleTrunk2,
    SimpleTrunk22,
    SimpleTrunk3,
    SimpleTrunk32,
    SimpleTrunk4,
    SensibleTrunk,
    SensibleTrunk2,
    MethodApplicability,
    SeismicRexApplicability,
    InspectionCriteria,
    InspectionCriteria1a,
    InspectionCriteria2,
    InspectionCriteria3,
    InspectionCriteria4,
    InspectionCriteria4a,
    InspectionCriteria5,
    InspectionCriteria5a,
    InspectionCriteria6,
    SeismicCapacity
  },

  mounted () {
    this.activatePrintablePDFMode()
    this.campaign = this.$route.params.campaign
    this.campaignForms = this.getSeismicForms.filter((item: SeismicForm) => item.campaign === this.campaign)
    this.injectSignatures()
    setTimeout(() => {
      this.$set(this, 'activeForm', this.campaignForms[this.activeFormIndex]) //= this.campaignForms[this.activeFormIndex]
    }, 500)
  },
  beforeDestroy () {
    this.deactivatePrintablePDFMode()
  },
  methods: {
    ...mapActions(['activatePrintablePDFMode', 'deactivatePrintablePDFMode', 'insertInspector']),

    createUser (firstName: string, lastName: string, SQUGDate?: Date) {
      const fr = new FileReader()
      fr.onload = () => {
        const signatureDataURL = fr.result as string
        this.insertInspector(new Inspector(firstName, lastName, signatureDataURL, SQUGDate))
      }

      // eslint-disable-next-line
      const file = (this.$el.querySelector(`${firstName.replace(' ', '-')}-${lastName.replace(' ', '-')}`) as any).files[0]
      fr.readAsDataURL(file)
    },

    // eslint-disable-next-line @typescript-eslint/ban-types
    async exportPDF (callback?: Function) {
      const opt = {
        margin: 1,
        filename: this.activeForm?.numeroFiche,
        html2canvas: { scale: 4 },
        jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
      }
      await html2pdf().set(opt).from(document.querySelector('#document-to-print')).save().then(() => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        setTimeout(callback!, 10)
      })
    },

    sequentialExport () {
      this.pendingImport = true
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this

      async function exportCallback () {
        if (++self.activeFormIndex < self.campaignForms.length) {
          // Empty form to force DOM unbind/unmount (because of weird behavior after html2pdf export)
          self.activeForm = undefined
          self.$forceUpdate()
          await self.$nextTick()

          // Recreate DOM with right data for html2pdf
          self.activeForm = self.campaignForms[self.activeFormIndex]
          await self.$nextTick()
          await self.exportPDF(exportCallback)
        } else {
          console.log('Terminé')
        }
      }

      this.activeFormIndex = 0
      this.exportPDF(exportCallback)
    },

    injectSignatures () {
      this.campaignForms.forEach((form: SeismicForm) => {
        // eslint-disable-next-line no-unused-expressions
        form.inspectors?.forEach((i: Inspector) => {
          try {
            i.signatureDataURL = this.getInspectors
              .find((fullInspector: Inspector) => i.firstName === fullInspector.firstName && i.lastName === fullInspector.lastName).signatureDataURL
            i.SQUGDate = new Date(this.getInspectors
              .find((fullInspector: Inspector) => i.firstName === fullInspector.firstName && i.lastName === fullInspector.lastName).SQUGDate)
          } catch {
            console.log('pas trouvé l\'utilisateur ', i.firstName)
          }
        })
      })
      this.$forceUpdate()
    }
  }
})

